module.exports = __webpack_public_path__ + "static/posterized_lighting-3984704c9daa67c70d30a26bbdc876a0.png";